import { answerParser } from './answer-parser'
import { i18nParser } from './i18n-parser'
import { Parser } from './interfaces'

export const parseScenario: Parser = async ({ scenario, state }) => {
  let newScenario = await answerParser({ scenario, state })
  newScenario = await i18nParser({ scenario: newScenario, state })

  return newScenario
}
